// extracted by mini-css-extract-plugin
export default {"info":"Dashboard_info__R5yNy","grid":"Dashboard_grid__TipWq"};